/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.modalModule')
.service('BulbModalService', ['$modal', '$modalStack', '$rootScope', '$sce', '$timeout', '$translate', '$window', 'Restangular', 'MODAL_ARIA', BulbModalService]);

function BulbModalService($modal, $modalStack, $rootScope, $sce, $timeout, $translate, $window, Restangular, MODAL_ARIA) {

  var that = this;

  /**
   *  We use this function to set the user preference 'showModalOnlyOnce' in the Account settings so we have it
   *  for use, instead of doing cookies to set the modal preference.
   */
  function setShowModalOnlyOnceFlag(wasChecked, prefType, BulbAuthService, ErrorService) {

    // Dynamically create the patch object to send to the server
    var prefPatch = {};
    var patch = {};
    prefPatch[prefType] = wasChecked;
    patch.prefs= prefPatch;

    Restangular.one('accounts', BulbAuthService.currentUser.id)
      .patch(patch)
      .then(function (updatedAccount) {
        BulbAuthService.setCurrentUser(updatedAccount);
      })
      .catch(function(error) {
        ErrorService.handleException(error);
      });
  }

  var defaultModalOptions = {
    templateUrl: 'ajs/components/modal/modal.html'
  };

  var defaultOptions = {
    titleCode: 'modal_default_title',
    bodyCode: 'modal_default_body',
    offline: false,
    okButtonCode: 'button_ok',
    cancelButtonCode: 'button_cancel',
    showOkButton: true,
    showCancelButton: true,
    // DO LATER: keyboard: true is supposed to allow closing the dialog with ESC, but it does not work.
    keyboard: true,
    backdrop: true,
    closeOnClick: true
  };

  // DO LATER: Should handle keyboard input correctly: disable focusing anything under the busy backdrop.
  // Dojo does this beautifully, but Foundation does not.
  this.open = function(options) {
    var tempOptions = angular.extend({}, defaultOptions, options);

    // Make sure we allow html in the body text to be displayed:
    if (tempOptions.bodyText) {
      tempOptions.bodyText = $sce.trustAsHtml(tempOptions.bodyText);
    }
    // We need to create different modalOptions if the app is offline:
    var modalOptions = (!options.offline) ? angular.copy(defaultModalOptions) : {};
    modalOptions.scope = tempOptions.scope ? $rootScope.$new(false, tempOptions.scope) : $rootScope.$new();
    modalOptions.scope.customOptions = tempOptions;
    modalOptions.controller = tempOptions.controller;
    if(tempOptions.scope) {
      modalOptions.scope = tempOptions.scope;
    }
    modalOptions.controllerAs = tempOptions.controllerAs;
    modalOptions.parent = tempOptions.parent || modalOptions.parent;
    modalOptions.windowClass = tempOptions.windowClass || modalOptions.windowClass;
    modalOptions.windowId = tempOptions.windowId || modalOptions.windowId;
    modalOptions.backdrop = tempOptions.backdrop;
    defaultOptions.keyboard = tempOptions.keyboard;
    if (tempOptions.keyboard === false) {
      modalOptions.keyboard = tempOptions.keyboard;
    }
    modalOptions.closeOnClick = tempOptions.closeOnClick;
    // Creating this object value needs to be inversed since we always want the default modalOptions value rather
    // Than the tempOptions value. The only time we want the temp options value is if the app goes offline.
    modalOptions.templateUrl = modalOptions.templateUrl || tempOptions.templateUrl;

    var modal = $modal.open(modalOptions);
    modal.focusAfterClosed = options.focusAfterClosed;
    //handle modal accessibility.
    this.setAccessibilityOnModal(modal);

    return modal;
  };

  /**
   * Function that generates unique ids for modals.
   */
  this.generateObjectId = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8); // jshint ignore:line
      return v.toString(16);
    });
  };

  /**
   * Function that will manage tab when Dialog (not moal) is opened
   * @param {*} modalDialog
   * @param {*} focusAfterClosed
   */
  this.setAccessibilityOnDialog = function(focusAfterClosed) {
    $timeout(function() {
      var modalDialogs = $('div[role="dialog"]');
      if(modalDialogs.length > 0) {
        // loop for managing modal over modal situation
        for(var i = 0; i < modalDialogs.length; i++) {
          var modalDialog = $(modalDialogs[i]);
          if (typeof modalDialog.attr('id') === typeof undefined) {
            var focusFirst = that.setTabOrderOnModal(modalDialog);
            if (modalDialog.length === 1) {
              $('.reveal-modal-bg').attr('role', 'none');
              var dialogId = modalDialog.attr('id');
              // code for append accessibility on opened dialog
              new MODAL_ARIA.Dialog(dialogId, focusAfterClosed, focusFirst);
            }
          }
        }
      }
    }, MODAL_ARIA.MODAL_TIMEOUT);
  };

  /**
   * Function that incorporate accessibility in modal dialog.
   *
   * @param modal,
   * @returns {*}
   */
  this.setAccessibilityOnModal = function(modal) {
    modal.opened.then(function() {
      $timeout(function() {
        var modalDialogs = $('div[role="dialog"]');
        if(modalDialogs.length > 0) {
          // loop for managing modal over modal situation
          for(var i = 0; i < modalDialogs.length; i++) {
            var modalDialog = $(modalDialogs[i]);
            if (typeof modalDialog.attr('id') === typeof undefined) {
              var focusFirst = that.setTabOrderOnModal(modalDialog);
              if (modalDialog.length === 1) {
                $('.reveal-modal-bg').attr('role', 'none');
                var dialogId = modalDialog.attr('id');
                var focusAfterClosed = $(modal.focusAfterClosed);

                // this code will identify aero dialog recently closed and then
                // handle modal accessibility of parent modal
                var lastModalValue = localStorage.getItem(MODAL_ARIA.AERO_DIALOG_KEY);
                if(lastModalValue) {
                  var lastModal = JSON.parse(lastModalValue);
                  if(MODAL_ARIA.OpenDialogList.length === 1 && lastModal.modalClass.includes('aero-dialog')) {
                    focusFirst = $('.' + lastModal.lastFocusClass.split(' ')[0]);
                    focusAfterClosed = MODAL_ARIA.OpenDialogList[0].focusAfterClosed;
                    localStorage.removeItem(MODAL_ARIA.AERO_DIALOG_KEY);
                    MODAL_ARIA.OpenDialogList.pop();
                  }
                }
                // code for append accessibility on opened modal
                new MODAL_ARIA.Dialog(dialogId, focusAfterClosed, focusFirst);

              }
            }
          }
        }
      }, MODAL_ARIA.MODAL_TIMEOUT);
    });
  };

  /**
   * Function that shows a modal, and returns the resolved promise when a modal is closed and rejected when a modal is
   * Disimissed.
   *
   * @param options
   * @returns {*}
   */
  this.show = function(options) {
    return this.open(options).result;
  };

  /**
   * Fuction that shows a custom modal, and returns the resolved promise when a modal is closed and rejected when a custom modal is
   * Disimissed.
   *
   * @param options
   * @returns {*}
   */
  this.showCustomModal = function(options) {
    var modal = $modal.open(options);
    modal.focusAfterClosed = options.focusAfterClosed;
    //handle custom modal accessibility.
    this.setAccessibilityOnModal(modal);
    return modal;
  };

  /**
   * Function that clear the DOM after modal is closed via cancel button.
   * @param event event triggered at the modal.
   */
  this.cancel = function (event) {
    event.preventDefault();
    event.stopPropagation();
    this.clearDialog(event);
  };

  /**
   * Function that clear the DOM after modal close
   * @param event event triggered at the modal.
   */
  this.clearDialog = function(event) {
    var modal = $modalStack.getTop();
    if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && (event.target === event.currentTarget)) {
      $modalStack.dismiss(modal.key, 'backdrop click');
    }
    var currentDialog = MODAL_ARIA.getCurrentDialog();
    if(currentDialog) {
      that.setAeroDialogModal(currentDialog);
      $timeout(function() {
        if (MODAL_ARIA.closeCurrentDialog()) {
          // Empty dialog array :
          MODAL_ARIA.OpenDialogList = [];
          event.stopPropagation();
        }
      }, MODAL_ARIA.MODAL_TIMEOUT);
    }
  };

  /**
   * Function that shows the modal, and returns the modal instance itself.
   *
   * @param options Options object for the modal instance.
   * @returns A modal instance, an object with the following properties:
   *
   * - close(result) (Type: function) - Can be used to close a modal, passing a result.
   * - dismiss(reason) (Type: function) - Can be used to dismiss a modal, passing a reason.
   * - result (Type: promise) - Is resolved when a modal is closed and rejected when a modal is dismissed.
   * - opened (Type: promise) - Is resolved when a modal gets opened after downloading content's template and resolving all variables.
   * - closed (Type: promise) - Is resolved when a modal is closed and the animation completes.
   * - rendered (Type: promise) - Is resolved when a modal is rendered.
   */
  this.alert = function(options) {
    return this.open(options);
  };

  /**
   * Function that will only show the modal once and run the update callback provided by the user.
   *
   * The BulbAuthService and ErrorService need to be passes as parameters since injecting them in during the
   * Service instantiation will create a circular dependency.
   *
   * @param options ModalOptions object that the modal will display.
   * @param submitCallBack The function that gets called when the user hits 'ok' || 'sumbit'
   * @param cancelCallBack The function that gets called when the user hits 'cancel'
   * @param prefType The specific type of preference modal to only ever show once. This could be smart paste modal,
   * state modal, etc...
   *
   * The dev would need to create the new pref on the backend as well, in order to target specific preferences.
   *
   * @param BulbAuthService
   * @param ErrorService
   */
  this.showModalOnlyOnce = function(options, submitCallBack, cancelCallBack, prefType, BulbAuthService, ErrorService) {
    return this.open(options).result.then( function submit() {
      if (typeof submitCallBack === 'function' && submitCallBack()) {
        submitCallBack();
      }
    }, function cancel() {
      if (typeof cancelCallBack === 'function' && cancelCallBack()) {
        cancelCallBack();
      }
    }).finally( function updateAccountPrefs() {
      var wasChecked = $('#showModalOnlyOnce').is(':checked');
      if (wasChecked) {
        setShowModalOnlyOnceFlag(wasChecked, prefType, BulbAuthService, ErrorService);
      }
    });
  };

  this.showMessage = function(key, srcOptions, args) {
    return $translate(key, args).then(function(message) {
      var options = {
        titleCode: '',
        showOkButton: true,
        showCancelButton: false,
        templateUrl: 'ajs/components/modal/message-modal.html',
        windowClass: 'scrollable',
        controller: [ '$scope', function($scope) {
          $scope.message = message;
        } ]
      };
      return that.open(angular.extend({}, options, srcOptions));
    });
  };

  this.initScrollableModalLayoutHandler = function($scope) {
    var pageContent = $('body > .bulb-main').eq(0);
    var modalBgOuter = $('body').find('.modal-bg-outer');

    var getLastScrollTop = function() {
      return $('body').scrollTop() || $('html').scrollTop();
    };

    var lastScrollTop = getLastScrollTop();
    var isLastSmall = null;

    var updateModalLayout = function() {

      /* jshint camelcase: false */
      var small = Foundation.utils.is_small_only();
      if (isLastSmall === null || isLastSmall !== small) {
        if (!small) {
          lastScrollTop = getLastScrollTop();
          pageContent.css('width', '100%');
        }
        isLastSmall = small;
      }
    };

    $($window).on('resize', updateModalLayout);

    updateModalLayout();
    pageContent.css('position', 'fixed');
    pageContent.css('top', -lastScrollTop);
    modalBgOuter.css('position', 'absolute');
    /**
     * As of now, we need to explicitly set the modalBgOuter style 'top' property to !important because
     * we need it to override the 'top' value that _modal.scss is displaying. Without it, the issue stated in
     * BULB-249 appears.
     */
    if(!Foundation.utils.is_small_only()) { // jshint ignore:line
      $('body').css('overflow', 'hidden');
      modalBgOuter.attr('style', function(styleAttribute, computedValue) {
        return computedValue + 'top:' + (lastScrollTop) + 'px !important;';
      });
    }


    /* jshint camelcase: false */
    if (Foundation.utils.is_small_only()) {
      $('body,html').scrollTop(0);
    }

    $scope.$on('$destroy', function() {
      $($window).off('resize', updateModalLayout);
      if (!that.getTopModalElement()) {
        $('body').css('overflow', '');
        pageContent.css('position', '');
        pageContent.css('top', '');
        modalBgOuter.css('position', '');
        pageContent.css('width', '');
      }
      $('body,html').scrollTop(lastScrollTop);
    });
  };

  this.getTopModalElement = function() {
    var top = $modalStack.getTop();
    return top ? $(top.value.modalDomEl[0]) : null;
  };

  this.dismissAllModals = function () {
    $modalStack.dismissAll();
  };

  /**
   * Function that places tab order on the modal
   * @param {*} modalHeadings
   */
  this.setTabOrderOnModal = function(modalDialog) {
    var focusFirst;
    var modalId = that.generateObjectId();
    modalDialog.attr('id', modalId);
    if(modalDialog.attr('aria-label') === undefined) {
      modalDialog.attr('aria-label', 'modal');
    }
    if(modalDialog.attr('aria-modal') === undefined) {
      modalDialog.attr('aria-modal', 'true');
    }
    var modalHeadings = $('.bulb-modal-body h1');
    if(modalDialog.attr('class').includes('aero-dialog')) {
      modalHeadings = $('.audio-recording-container h1');
    }
    // this will take care of modal's heading tabindex
    for(var j = 0; j < modalHeadings.length; j++) {
      var modalHeading = $(modalHeadings[j]);
      if (typeof modalHeading.attr('id') === typeof undefined && $(modalHeading).text() !== '') {
        modalHeading.attr('tabindex', '0');
        focusFirst = modalHeading;
        break;
      }
    }
    // this will take care of modal content focusable element's tabbing
    var modalContentElements = $('.bulb-modal-content').find(':focusable');
    if(modalContentElements.length === 0) {
      $(modalContentElements.prevObject).attr('tabindex', '0');
      $(modalContentElements.prevObject).attr('role', 'heading');
      $(modalContentElements.prevObject).attr('aria-level', '2');
      if(!focusFirst) {
        focusFirst = $(modalContentElements.prevObject);
      }
    } else if(modalContentElements.length === 1 && modalContentElements.hasClass('ps__scrollbar-y')) {
      // this shows modal only have scrollbar
      $(modalContentElements.prevObject).attr('tabindex', '0');
      $(modalContentElements.prevObject).attr('role', 'heading');
      $(modalContentElements.prevObject).attr('aria-level', '2');
      if(!focusFirst) {
        focusFirst = $(modalContentElements.prevObject);
      }
      // okay to add a generic id here, because we know we only have 1 modal in this case.
      var scrollId = 'scroll-id';
      var scrollClass = $('.ps__scrollbar-x-rail');
      if (scrollClass.length > 0) {
        $(scrollClass[0]).attr('id', scrollId);
        $('.ps__scrollbar-y').attr('aria-controls', scrollId);
      }
    } else {
      // this will assign tabindex to first focusable element
      for(var k = 0; k < modalContentElements.length; k++) {
        var modalContentElement =$(modalContentElements[k]);
        if(!modalContentElement.is('form')) {
          modalContentElement.attr('tabindex', '0');
          if(!focusFirst) {
            focusFirst = modalContentElement;
          }
          break;
        }
      }
    }
    return focusFirst;
  };

  /**
   * Function that store aero dialog info in local storage
   * @param {*} currentDialog
   */
  this.setAeroDialogModal = function(currentDialog) {
    var lastModal = {
      modalClass : $(currentDialog.dialogNode).attr('class'),
      lastFocusClass: $(currentDialog.focusAfterClosed).attr('class')
    };
    if(lastModal.modalClass.includes('aero-dialog')) {
      localStorage.setItem(MODAL_ARIA.AERO_DIALOG_KEY, JSON.stringify(lastModal));
    }
  };
  // switch multiple modal visibility
  $rootScope.$watch(function() {
    return $modalStack.getTop();
  }, function(newModal, beforeModal) {

    var newModalBusy = false;
    var newModalElement = null;
    var beforeModalElement = null;

    if (newModal && newModal.value) {
      newModalElement = $(newModal.value.modalDomEl[0]);
      newModalBusy =  newModalElement.find('.bulb-modal-body').eq(0).children('.bulb-busy').length > 0;
    }

    if (beforeModal && beforeModal.value) {
      beforeModalElement = $(beforeModal.value.modalDomEl[0]);
    }

    if (newModalElement) {
      newModalElement.stop().fadeIn(50);
    }

    if (!newModalBusy && beforeModalElement) {
      beforeModalElement.stop().fadeOut(MODAL_ARIA.MODAL_TIMEOUT);
    }
  });

  /**
  * @desc Method that removes modal item.
  * @param item
  *          DOM node for which to get the removable item.
   * @returns
   *  true if item removed.
   */
  MODAL_ARIA.Utils.remove = function (item) {
    if (item.remove && typeof item.remove === 'function') {
      return item.remove();
    }
    if (item.parentNode && item.parentNode.removeChild && typeof item.parentNode.removeChild === 'function') {
      return item.parentNode.removeChild(item);
    }
    return false;
  };

  /**
  * @desc Method that checks element is focusable or not
  * @param element
  *          DOM node for which to find the focusable element.
   * @returns
   *  true if an element is focusable.
   */
  MODAL_ARIA.Utils.isFocusable = function (element) {
    if (element.tabIndex > 0 || (element.tabIndex === 0 && element.getAttribute('tabIndex') !== null)) {
      return true;
    }

    if (element.disabled) {
      return false;
    }

    switch (element.nodeName) {
      case 'A':
        return !!element.href && element.rel !== 'ignore';
      case 'INPUT':
        return element.type !== 'hidden' && element.type !== 'file';
      case 'BUTTON':
      case 'SELECT':
      case 'TEXTAREA':
        return true;
      default:
        return false;
    }
  };

  /**
   * @desc Set focus on descendant nodes until the first focusable element is
   *       found.
   * @param element
   *          DOM node for which to find the first focusable descendant.
   * @returns
   *  true if a focusable element is found and focus is set.
   */
  MODAL_ARIA.Utils.focusFirstDescendant = function (element) {
    for (var i = 0; i < element.childNodes.length; i++) {
      var child = element.childNodes[i];
      if (MODAL_ARIA.Utils.attemptFocus(child) ||
        MODAL_ARIA.Utils.focusFirstDescendant(child)) {
        return true;
      }
    }
    return false;
  };

  /**
   * @desc Find the last descendant node that is focusable.
   * @param element
   *          DOM node for which to find the last focusable descendant.
   * @returns
   *  true if a focusable element is found and focus is set.
   */
  MODAL_ARIA.Utils.focusLastDescendant = function (element) {
    for (var i = element.childNodes.length - 1; i >= 0; i--) {
      var child = element.childNodes[i];
      if (MODAL_ARIA.Utils.attemptFocus(child) ||
        MODAL_ARIA.Utils.focusLastDescendant(child)) {
        return true;
      }
    }
    return false;
  };

  /**
   * @desc Set Attempt to set focus on the current node.
   * @param element
   *          The node to attempt to focus on.
   * @returns
   *          true if element is focused.
   */
  MODAL_ARIA.Utils.attemptFocus = function (element) {
    if (!MODAL_ARIA.Utils.isFocusable(element)) {
      return false;
    }

    MODAL_ARIA.Utils.IgnoreUtilFocusChanges = true;
      try {
        element.focus();
      } catch (e) {
        // continue regardless of error
      }
    MODAL_ARIA.Utils.IgnoreUtilFocusChanges = false;
    return (document.activeElement === element);
  };

  /**
   * @desc Method that gets current dialog.
   * @returns The last opened dialog (the current dialog)
   */
  MODAL_ARIA.getCurrentDialog = function () {
    if (MODAL_ARIA.OpenDialogList && MODAL_ARIA.OpenDialogList.length) {
      return MODAL_ARIA.OpenDialogList[MODAL_ARIA.OpenDialogList.length - 1];
    }

  };

  /**
  * @desc Method that closes focused dialog.
   * @returns
   *          true if dialog closed.
   */
  MODAL_ARIA.closeCurrentDialog = function () {
    var currentDialog = MODAL_ARIA.getCurrentDialog();
      if (currentDialog) {
        currentDialog.close();
        return true;
      }

    return false;
  };

  /**
   * @desc Method that handles Esc keypress action.
   * @param event
   *          The Esc keypress event.
    */
  MODAL_ARIA.handleEscape = function (event) {
    if (event.key === 'Escape' && defaultOptions.keyboard) {
      var modal = $modalStack.getTop();
      if (modal) {
        $modalStack.dismiss(modal.key, 'backdrop click');
      }
      var currentDialog = MODAL_ARIA.getCurrentDialog();
      if(currentDialog) {
        that.setAeroDialogModal(currentDialog);
        if(MODAL_ARIA.closeCurrentDialog()){
          event.stopPropagation();
        }
      }
    }
  };

    document.addEventListener('keyup', MODAL_ARIA.handleEscape);

  /**
   * @constructor
   * @desc Dialog object providing modal focus management.
   *
   * Assumptions: The element serving as the dialog container is present in the
   * DOM and hidden. The dialog container has role='dialog'.
   *
   * @param dialogId
   *          The ID of the element serving as the dialog container.
   * @param focusAfterClosed
   *          Either the DOM node or the ID of the DOM node to focus when the
   *          dialog closes.
   * @param focusFirst
   *          Optional parameter containing either the DOM node or the ID of the
   *          DOM node to focus when the dialog opens. If not specified, the
   *          first focusable element in the dialog will receive focus.
   * @param ErrorService
   */
  MODAL_ARIA.Dialog = function (dialogId, focusAfterClosed, focusFirst, ErrorService) {
    this.dialogNode = document.getElementById(dialogId);
    if (this.dialogNode === null) {
      ErrorService.handleException(new Error('No element found with id="' + dialogId + '".'));
    }

    var validRoles = ['dialog', 'alertdialog'];
    var isDialog = (this.dialogNode.getAttribute('role') || '')
    .trim()
    .split(/\s+/g)
    .some(function (token) {
      return validRoles.some(function (role) {
        return token === role;
      });
    });
    if (!isDialog) {
      ErrorService.handleException(new Error('Dialog() requires a DOM element with ARIA role of dialog or alertdialog.'));
    }

    // Wrap in an individual backdrop element if one doesn't exist
    // Native <dialog> elements use the ::backdrop pseudo-element, which
    // works similarly.
    var backdropClass = 'dialog-backdrop';
    if (this.dialogNode.parentNode.classList.contains(backdropClass)) {
      this.backdropNode = this.dialogNode.parentNode;
    } else {
      this.backdropNode = document.createElement('div');
      this.backdropNode.className = backdropClass;
      this.dialogNode.parentNode.insertBefore(this.backdropNode, this.dialogNode);
      this.backdropNode.appendChild(this.dialogNode);
    }
    this.backdropNode.classList.add('active');

    // Disable scroll on the body element
    document.body.classList.add(MODAL_ARIA.Utils.dialogOpenClass);

    if (typeof focusAfterClosed === 'string') {
      this.focusAfterClosed = document.getElementById(focusAfterClosed);
    } else if (typeof focusAfterClosed === 'object') {
      this.focusAfterClosed = focusAfterClosed;
    } else {
      ErrorService.handleException(new Error('the focusAfterClosed parameter is required for the MODAL_ARIA.Dialog constructor.'));
    }

    if (typeof focusFirst === 'string') {
      this.focusFirst = document.getElementById(focusFirst);
    } else if (typeof focusFirst === 'object') {
      this.focusFirst = focusFirst;
    } else {
      this.focusFirst = null;
    }

    // Bracket the dialog node with two invisible, focusable nodes.
    // While this dialog is open, we use these to make sure that focus never
    // leaves the document even if dialogNode is the first or last node.

    // If this modal is opening on top of one that is already open,
    // get rid of the document focus listener of the open dialog.
    if (MODAL_ARIA.OpenDialogList.length > 0) {
      MODAL_ARIA.getCurrentDialog().removeListeners();
    }

    this.addListeners();
    MODAL_ARIA.OpenDialogList.push(this);

    if (this.focusFirst) {
      this.focusFirst.focus();
    } else {
      MODAL_ARIA.Utils.focusFirstDescendant(this.dialogNode);
    }

    this.lastFocus = document.activeElement;
  };

  /**
   * @desc Method that clears values of all inputs residing in dialog.
    */
  MODAL_ARIA.Dialog.prototype.clearDialog = function () {
    Array.prototype.map.call(this.dialogNode.querySelectorAll('input'), function (input) {
      if(!input.hasAttribute('readonly')){
        input.value = '';
      }
    });
  };

  /**
   * @desc
   *  Hides the current top dialog,
   *  removes listeners of the top dialog,
   *  restore listeners of a parent dialog if one was open under the one that just closed,
   *  and sets focus on the element specified for focusAfterClosed.
   */
  MODAL_ARIA.Dialog.prototype.close = function () {
    MODAL_ARIA.OpenDialogList.pop();
    this.removeListeners();
    if(this.preNode) {
      MODAL_ARIA.Utils.remove(this.preNode);
    }
    if(this.postNode) {
      MODAL_ARIA.Utils.remove(this.postNode);
    }
    this.dialogNode.className = 'hidden';
    this.backdropNode.classList.remove('active');
    /**
     * This will reshow editable content so that button can gain focus after
     * modal popup closed
     */
    if($(this.focusAfterClosed).hasClass('bulb-insert-block-buttons-media')) {
      var mediaEditor = $('.bulb-insert-block-buttons-media').parent().parent();
      $(mediaEditor.find('p')[0]).addClass('bulb-media-active');
      $(mediaEditor.find('div')[0]).removeClass('hide');
      mediaEditor.attr('data-medium-focused', 'true');
    }
    /**
     * This will remove dialog overlay div
     */
    var overlay = $('.ui-widget-overlay');
    if(overlay.length === 1) {
      overlay.remove();
    }
    this.focusAfterClosed.focus();

    // If a dialog was open underneath this one, restore its listeners.
    if (MODAL_ARIA.OpenDialogList.length > 0) {
      MODAL_ARIA.getCurrentDialog().addListeners();
    } else {
      document.body.classList.remove(MODAL_ARIA.Utils.dialogOpenClass);
    }
  };

  /**
  * @desc Method that bind focus event to document.
   */
  MODAL_ARIA.Dialog.prototype.addListeners = function () {
    document.addEventListener('focus', this.trapFocus, true);
  };

  /**
   * @desc Method that unbing focus event to document.
    */
  MODAL_ARIA.Dialog.prototype.removeListeners = function () {
    document.removeEventListener('focus', this.trapFocus, true);
  };

  /**
   * @desc Method thet traps focus on the most top dialog.
   * @param event
   *          The node to attempt to focus.
   */
  MODAL_ARIA.Dialog.prototype.trapFocus = function (event) {
    if (MODAL_ARIA.Utils.IgnoreUtilFocusChanges) {
      return;
    }
    var currentDialog = MODAL_ARIA.getCurrentDialog();
    if (currentDialog) {
      if (currentDialog.dialogNode.contains(event.target)) {
        currentDialog.lastFocus = event.target;
      } else {
        MODAL_ARIA.Utils.focusFirstDescendant(currentDialog.dialogNode);
        if (currentDialog.lastFocus === document.activeElement) {
          MODAL_ARIA.Utils.focusLastDescendant(currentDialog.dialogNode);
        }
        currentDialog.lastFocus = document.activeElement;
      }
    }
  };
}


